var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_link"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1779 777a387 387 0 0 0-360-535 386 386 0 0 0-275 114L959 541a64 64 0 1 0 90 90l185-185a259 259 0 0 1 369 0 259 259 0 0 1 0 369l-185 185a64 64 0 1 0 91 90l185-185c37-37 65-80 85-128zM1090 1418a64 64 0 0 0-90 0l-185 185a259 259 0 0 1-369 0 259 259 0 0 1 0-369l185-185a64 64 0 1 0-91-90l-185 185a387 387 0 0 0 129 635 387 387 0 0 0 421-86l185-185c25-24 25-65 0-90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M849 1290l444-443a64 64 0 1 0-91-91l-444 444a64 64 0 1 0 91 90z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairedIcon);
export default __webpack_public_path__ + "static/media/paired_icon.fe449f16fe2cefc31781659e67091282.svg";
export { ForwardRef as ReactComponent };